<template>
    <div
        class="custom-control custom-checkbox"
        :class="[
            { 'custom-checkbox-lg': large },
            { 'pe-none': radioType && localValue }
        ]"
    >
        <input
            type="checkbox"
            class="custom-control-input"
            :id="name"
            :name="name"
            v-model="localValue"
            :disabled="disabled"
            :required="required"
        />
        <label class="custom-control-label d-flex" :for="name">
            <span
                v-html="label"
                :style="'padding-top: 1px'"
                v-tooltip="tooltipLabel"
            ></span>
            <a-icon
                style="min-width: 16px; width: 16px"
                v-if="tooltip"
                v-tooltip="tooltip"
                class="ml-1"
                icon="Info"
            />
        </label>
    </div>
</template>

<script>
export default {
    name: 'UiCheckboxInput',
    props: {
        label: {
            type: String,
            default: ''
        },
        name: {
            type: String,
            required: true
        },
        value: {
            type: Boolean,
            default: false
        },
        disabled: {
            typ: Boolean,
            default: false
        },
        required: {
            typ: Boolean,
            default: false
        },
        large: {
            type: Boolean,
            default: false
        },
        tooltip: {
            type: String,
            required: false
        },
        tooltipLabel: {
            type: String,
            required: false
        },
        radioType: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        localValue: {
            get() {
                return this.value
            },
            set(value) {
                this.$emit('input', value)
                this.$emit('change', value)
            }
        }
    }
}
</script>

<style lang="scss">
.custom-control.custom-checkbox {
    .custom-control-label {
        line-height: 1.5;
        font-size: inherit;
        cursor: pointer;
        &::before {
            border: 1px solid var(--color-gray-500);
        }
    }
}
</style>
